import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, modifiers } from '../styles.js'
import array from '@mailobj-browser/front/js/utils/array.js'

const clicks = new WeakSet()
const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    next
  ) => {
    const { ownerDocument } = next

    if (clicks.has(ownerDocument)) {
      return
    }

    clicks.add(ownerDocument)

    requestAnimationFrame(() => {
      const container = next.closest(`.${elements.library}`)
      const list = one('ul', container)
      const pages = list.children
      const nbPages = pages.length

      let curPage = 0
      let nextPage = -1
      for (let idPage = 0; idPage < nbPages; idPage++) {
        if (pages[idPage].classList.contains(modifiers.library_counter_increment_pages.hide)) {
          continue
        }
        curPage = idPage
        nextPage = curPage + 1
      }
      if (nextPage === nbPages) {
        nextPage = 0
      }

      for (let idPage = 0; idPage < nbPages; idPage++) {
        if (idPage === nextPage) {
          pages[idPage].removeAttribute('aria-hidden')
          pages[idPage].classList.remove(modifiers.library_counter_increment_pages.hide)
        } else if (!pages[idPage].getAttribute('aria-hidden') === true) {
          pages[idPage].setAttribute('aria-hidden', true)
          pages[idPage].classList.add(modifiers.library_counter_increment_pages.hide)
        }
      }

      clicks.delete(ownerDocument)
    })
  }
})

export default next => {
  onClick.listen(next)
}